import { makeAutoObservable } from 'mobx';

import { BackorderLogic } from '~/api/BacorderLogic';
import {
  type IAgeRestrictionSettings,
  type IRestrictedCommodityGroup,
  type ISettingsRequestDTO,
  SettingsRequests,
} from '~/api/Settings';
import { company } from '~/company/Company';

export class SettingsStore {
  settings: ISettingsRequestDTO['data'] = {
    backorderLogic: BackorderLogic.ORIGINAL,
  };

  ageRestrictionSettings: IAgeRestrictionSettings | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  get maxMinAge(): number {
    const restrictedGroups = this.restrictedCategories;
    if (!restrictedGroups.length) {
      return 0;
    }
    return Math.max(...restrictedGroups.map((g) => g.min_age));
  }

  get restrictedCategories(): IRestrictedCommodityGroup[] {
    return this.ageRestrictionSettings?.restricted_commodity_groups ?? [];
  }

  getMinAgeForItems(
    items: { commodityGroup?: Nullable<{ name: string }> }[],
  ): number | null {
    const restrictedGroups = this.restrictedCategories;
    if (!restrictedGroups.length || !items.length) {
      return 0;
    }

    const itemGroupNames = items
      .map((item) => item.commodityGroup?.name)
      .filter(Boolean) as string[];

    const matchingAges = restrictedGroups
      .filter((group) => itemGroupNames.includes(group.name))
      .map((group) => group.min_age);

    return matchingAges.length ? Math.max(...matchingAges) : null;
  }

  async requestSettings() {
    const res = await SettingsRequests.getSettings();
    this.settings = res.data;

    if (company.hasAgeRestriction) {
      this.requestAgeRestrictionSettings();
    }
  }

  async requestAgeRestrictionSettings() {
    const res = await SettingsRequests.getAgeRestrictionSettings();
    this.ageRestrictionSettings = res.data.ageRestriction;
  }
}
